import React from "react";
import { NavLink, useLocation } from "react-router-dom"; // Import NavLink from react-router-dom
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
  FaCheckCircle,
} from "react-icons/fa";
import logo from "../../assets/img/logoApp.png";
import pisa from "../../assets/img/pisa.png";
import oced from "../../assets/img/Oced.png";
import ontario from "../../assets/img/LOGO_ACCREDITATION_ONTARIO.png";
const socialLinks = [
  { Icon: FaFacebook, url: "https://www.facebook.com/profile.php?id=61573524723696" },
  { Icon: FaInstagram, url: "https://www.instagram.com/fcis_sn/" },
  { Icon: FaTwitter, url: "https://x.com/home?lang=en" },
  { Icon: FaLinkedin, url: "https://www.linkedin.com/in/fcis-fcis-9b2088353/" }, // Remplace "#" par le lien LinkedIn
  { Icon: FaYoutube, url: "#" }, // Remplace "#" par le lien YouTube
];
const Footer = () => {
  const { pathname } = useLocation();
  const isSenegalCampus = pathname.includes("/campus/SENEGAL");
  const isCamerounCampus = pathname.includes("/campus/CAMEROUN");
  return (
    <footer className="footer-06">
      <div className="container">
        <div>
          <div className="col-md-3 d-flex justify-content-center justify-content-md-start my-3 p-0">
            <img
              loading="lazy"
              src={logo}
              alt="Logo"
              className="p-1 bg-white"
              width={120}
              height="auto"
            />
          </div>
        </div>
        <div className="row pt-4">
          <div className="col-md-6 col-lg-8">
            <div className="row">
              <div className="col-md-4 mb-md-0 mb-4">
                <h2 className="footer-heading">LIENS RAPIDES</h2>
                <ul className="list-unstyled">
                  <li>
                    <NavLink to="/" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />
                      ACCEUIL
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/about" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />A propos
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#partenaire" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />
                      Partenaires
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#actualite" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />
                      Actualites
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/contacts" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />
                      Contact
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div className="col-md-4 mb-md-0 mb-4">
                <h2 className="footer-heading">À PROPOS</h2>
                <ul className="list-unstyled">
                  <li>
                    <NavLink to="/about" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />
                      Etudier chez nous ?
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/about" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />
                      Nos valeurs
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/about" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />
                      Commite
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/pdg" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />
                      PDG
                    </NavLink>
                  </li>
                </ul>
              </div>

              <div className="col-md-4 mb-md-0 mb-4">
                <h2 className="footer-heading">PROGRAMMES</h2>
                <ul className="list-unstyled">
                  <li>
                    <NavLink to="/prepa-gd" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />
                      Prepa universitaire
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/curriculum" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />
                      Curriculumn canadien
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/prepa-hybride" className="py-1 d-block">
                      <FaCheckCircle className="mr-1" />
                      Programme hybride
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 order-md-last">
            <div className="row justify-content-end">
              <div className="col-md-12 col-lg-9 text-md-left mb-md-0 mb-4">
                {isSenegalCampus && (
                  <>
                    <h2 className="footer-heading">
                      <NavLink to="/" className="logo">
                        F.C.I.S
                      </NavLink>
                    </h2>
                    <p className="copyright custom-p text-left">
                      FASS POINT E ( En face Ecole Manguier)
                    </p>
                    <p className="custom-p text-left">
                      Tel : +221 778 82 71 97/ +221 787 15 77 88
                    </p>
                    <p className="custom-p text-left">
                      Email: info@fcis-peci.com
                    </p>
                  </>
                )}
                {isCamerounCampus && (
                  <>
                    <h2 className="footer-heading">
                      <NavLink to="/" className="logo">
                        F.C.I.S
                      </NavLink>
                    </h2>
                    <p className="custom-p text-left">
                      Immeuble à coté de l’ancien cinéma Douala Bercy
                    </p>
                    <p className="custom-p text-left">
                      Tel : +237 656 11 81 68 / +237 697 12 62 56
                    </p>
                    <p className="custom-p text-left">
                      Akwa Tel : +237 698353579 / +237 652009918 Logpom
                    </p>
                    <p className="custom-p text-left">
                      Email: info@fcis-peci.com
                    </p>
                  </>
                )}

                {!isSenegalCampus && !isCamerounCampus && (
                  <>
                    <h2 className="footer-heading">
                      <NavLink to="/" className="logo">
                        F.C.I.S
                      </NavLink>
                    </h2>
                    <p className="custom-p text-left">
                      FASS POINT E ( En face Ecole Manguier)
                    </p>
                    <p className="custom-p text-left">
                      Tel : +221 778 82 71 97/ +221 787 15 77 88
                    </p>
                    <p className="custom-p text-left">
                      Email: info@fcis-peci.com
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-md-3 col-lg-6 m-0 p-0">
            <div className="d-flex justify-content-center justify-content-md-start mb-3">
              {socialLinks.map(({ Icon, url }, index) => (
                <a key={index} href={url} target="_blank" rel="noopener noreferrer">
                  <Icon size={30} className="me-2 text-light" style={{ cursor: "pointer" }} />
                </a>
              ))}
            </div>
          </div>

          <div className="col-md-9 col-lg-6">
            <div className="white-border-left p-3 w-100">
              <p className="text-white subheading" style={{ fontSize: "12px" }}>
                F.C.I.S fait partie de l’élite mondiale des écoles de gestion
                détenant les 3 prestigieux agréments AMBA, AACSB International
                et EQUIS.
              </p>
              <div className="d-flex justify-content-center justify-content-md-start mt-2 mb-3">
                {[
                  { icon: pisa, alt: "pisa" },
                  { icon: oced, alt: "oced" },
                  { icon: ontario, alt: "ontario" },
                ].map((Icon, index) => (
                  <img
                    key={index}
                    src={Icon.icon}
                    alt={Icon.alt}
                    className="me-4"
                    width={40}
                    height={20}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
